import { useGet } from 'lib/api';
import { checkFeatureFlag } from '../utils';
import type { FeatureFlag } from '../types';
import { apiUsers } from 'api/users';

export const useFeatureFlag = (feature: string) => {
  const { data } = useGet<FeatureFlag>(
    apiUsers.get.featureFlags,
    'feature-flags',
    undefined,
    undefined,
    false
  );
  const hasAccess = checkFeatureFlag(feature, data);
  return hasAccess;
};
